import { Map } from 'maplibre-gl';
import { LayerParams } from "../map/layer-manager";

/**
 * Classe abstrata que representa uma camada a ser exibida no mapa.
 */
export abstract class MapLayer {

    /**
     * Remove a camada do mapa.
     * @param map mapa de onde a camada será removida.
     */
    abstract remove(map: Map): void;

    /**
     * Exibe a camada no mapa.
     * @param map mapa onde a camada será adicionada.
     * @param layerParams tem os dados necessários para a construção da camada.
     */
    abstract show(map: Map, layerParams: LayerParams): void;

    /**
     * Verifica se há dados disponíveis para a criação da camada.
     * @param layerParams tem os atributos dos dados.
     */
    abstract hasData(layerParams: LayerParams): boolean;
}